var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84113 38.2474C12.0892 38.2474 14.7223 36.9308 14.7223 35.3068C14.7223 33.6828 12.0892 32.3662 8.84113 32.3662C5.59305 32.3662 2.95996 33.6828 2.95996 35.3068C2.95996 36.9308 5.59305 38.2474 8.84113 38.2474Z",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95996 41.188C2.95996 42.8132 5.59277 44.1286 8.84113 44.1286C12.0895 44.1286 14.7223 42.8132 14.7223 41.188",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7223 35.3069V47.0692C14.7223 48.6944 12.0895 50.0098 8.84113 50.0098C5.59277 50.0098 2.95996 48.6944 2.95996 47.0692V35.3069",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4847 32.3663C29.7328 32.3663 32.3659 31.0497 32.3659 29.4257C32.3659 27.8017 29.7328 26.4851 26.4847 26.4851C23.2366 26.4851 20.6035 27.8017 20.6035 29.4257C20.6035 31.0497 23.2366 32.3663 26.4847 32.3663Z",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6035 41.188C20.6035 42.8132 23.2363 44.1286 26.4847 44.1286C29.7331 44.1286 32.3659 42.8132 32.3659 41.188",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6035 35.3069C20.6035 36.932 23.2363 38.2475 26.4847 38.2475C29.7331 38.2475 32.3659 36.932 32.3659 35.3069",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6035 29.4257C20.6035 31.0508 23.2363 32.3662 26.4847 32.3662C29.7331 32.3662 32.3659 31.0508 32.3659 29.4257",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3659 29.4257V47.0692C32.3659 48.6943 29.7331 50.0098 26.4847 50.0098C23.2363 50.0098 20.6035 48.6943 20.6035 47.0692V29.4257",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1282 26.4851C47.3763 26.4851 50.0094 25.1685 50.0094 23.5445C50.0094 21.9204 47.3763 20.6039 44.1282 20.6039C40.8802 20.6039 38.2471 21.9204 38.2471 23.5445C38.2471 25.1685 40.8802 26.4851 44.1282 26.4851Z",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2471 41.188C38.2471 42.8132 40.8799 44.1286 44.1282 44.1286C47.3766 44.1286 50.0094 42.8132 50.0094 41.188",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2471 35.3069C38.2471 36.932 40.8799 38.2475 44.1282 38.2475C47.3766 38.2475 50.0094 36.932 50.0094 35.3069",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2471 29.4257C38.2471 31.0508 40.8799 32.3662 44.1282 32.3662C47.3766 32.3662 50.0094 31.0508 50.0094 29.4257",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0094 23.5444V47.0691C50.0094 48.6943 47.3766 50.0097 44.1282 50.0097C40.8799 50.0097 38.2471 48.6943 38.2471 47.0691V23.5444",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.4455L50.0098 2.96045",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1885 1L50.0102 2.96039L46.0895 10.802",
    stroke: "#BFF32F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.2fe5347a6a560ba7ff01a009435e2207.svg";
export { ForwardRef as ReactComponent };